import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2394bcbc&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=2394bcbc&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2394bcbc')) {
      api.createRecord('2394bcbc', component.options)
    } else {
      api.reload('2394bcbc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2394bcbc&", function () {
      api.rerender('2394bcbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/fund-config/index.vue"
export default component.exports